/**
 * Cálculo de base imponible e IVA por línea para que el total coincida con la suma.
 * La última línea absorbe el redondeo.
 */
const VAT_PERCENT = 21;

function splitTotalIntoBaseAndVat(total, vatPercent = VAT_PERCENT) {
  const t = Math.round(total * 100) / 100;
  const baseApprox = t / (1 + vatPercent / 100);
  for (const delta of [0, 0.01, -0.01, 0.02, -0.02]) {
    const base = Math.round((baseApprox + delta) * 100) / 100;
    const vat = Math.round(base * (vatPercent / 100) * 100) / 100;
    if (Math.round((base + vat) * 100) / 100 === t) return { base, vat, total: t };
  }
  const base = Math.round(baseApprox * 100) / 100;
  const vat = Math.round((t - base) * 100) / 100;
  return { base, vat, total: t };
}

/**
 * Convierte líneas (concept, amount) en líneas con base e IVA.
 * La última línea absorbe el redondeo para que la suma coincida con grandTotal.
 * @param {{ concept: string, amount: number }[]} lineItems
 * @param {number} grandTotal
 * @returns {{ concept: string, base: number, vat: number, total: number }[]}
 */
export function splitLineAmountsIntoBaseAndVat(lineItems, grandTotal, vatPercent = VAT_PERCENT) {
  const totalR = Math.round(grandTotal * 100) / 100;
  if (!lineItems || lineItems.length === 0) {
    const { base, vat, total } = splitTotalIntoBaseAndVat(totalR, vatPercent);
    return [{ concept: 'Total', base, vat, total }];
  }
  if (lineItems.length === 1) {
    const { base, vat, total } = splitTotalIntoBaseAndVat(totalR, vatPercent);
    return [{ concept: lineItems[0].concept, base, vat, total }];
  }
  const result = [];
  let runningTotal = 0;
  for (let i = 0; i < lineItems.length - 1; i++) {
    const amount = Math.round(lineItems[i].amount * 100) / 100;
    const { base, vat, total } = splitTotalIntoBaseAndVat(amount, vatPercent);
    result.push({ concept: lineItems[i].concept, base, vat, total });
    runningTotal += total;
  }
  const lastRequired = Math.round((totalR - runningTotal) * 100) / 100;
  const { base, vat, total } = splitTotalIntoBaseAndVat(lastRequired, vatPercent);
  result.push({ concept: lineItems[lineItems.length - 1].concept, base, vat, total });
  return result;
}
